module.exports = __webpack_public_path__ + "img/W-19.a9fed0fe.jpg";